import React from 'react';
import { FaPalette, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import { ImageUploader } from '../../../components/ImageUploader';
import { CustomToggle } from '../../../components/CustomToggle';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { CustomInput } from '../../../components/CustomInput';
import { InfoDescription } from '../../../components/InfoDescription';
import { toastSuccess, toastError } from '../../../toasts';
import api from '../../../services/api';
import { IMAGES_PATH } from '../../../utils/imagesPath';
import { layoutSelectData } from '../constants';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import {
  ContainerLoja,
  ContentLoja,
  SettingsCard,
  CardHeader,
  ToggleRow,
  ColorPickerWrapper,
  ImageUploadWrapper,
  LojaInputWrapper,
} from './styles';

const appSelectThemeData = [
  { label: 'Claro (Light)', value: 'light' },
  { label: 'Escuro (Dark)', value: 'dark' },
  { label: 'Automático do Sistema', value: 'auto' },
];

const LogoThemes = ({ config, onChange, change, atualizar }) => {
  const { themeSchema, handleTheme, theme, handlePrimaryColor } =
    useCustomTheme();

  const updateImage = async (label, image) => {
    try {
      const formData = new FormData();
      formData.append(label, image);
      await api.patch(
        `/configuracao/imagem/alterar/${config.idConfig}`,
        formData,
      );
      toastSuccess('Dados alterados', 'Informação');
      atualizar();
    } catch (error) {
      toastError('Não foi possivel alterar imagem.');
    }
  };

  const deleteImage = async ({ label }) => {
    try {
      const data = { label };
      await api.patch(`/configuracao/imagem/deletar/${config.idConfig}`, data);
      atualizar();
    } catch (error) {
      toastError('Não foi possivel alterar imagem.');
    }
  };

  const saveLogoMarca = (image) => updateImage('Logomarca', image);
  const removeLogoMarca = () => deleteImage({ label: 'Logomarca' });

  return (
    <ContainerLoja>
      <ContentLoja>
        <SettingsCard>
          <CardHeader>
            <FaPalette />
            <h3>Identidade da Marca (App)</h3>
          </CardHeader>
          <ImageUploadWrapper>
            <InfoDescription
              label="Logotipo do Aplicativo (180 x 180px)"
              description="Recomenda-se uma imagem quadrada para melhor exibição no aplicativo do cliente."
            />
            <ImageUploader
              type={'logo'}
              src={config.logoMarca ? `${IMAGES_PATH}${config.logoMarca}` : ''}
              save={saveLogoMarca}
              remove={removeLogoMarca}
            />
          </ImageUploadWrapper>
          <ColorPickerWrapper>
            <InfoDescription
              label="Cor Principal do App"
              description="Define a cor dos botões e destaques no aplicativo do cliente."
            />
            <CustomInput
              type="color"
              value={config.tema || '#3b82f6'}
              onChange={onChange('tema')}
            />
          </ColorPickerWrapper>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaMobileAlt />
            <h3>Interface do Cliente</h3>
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label="Usar imagem de fundo"
              description="Ativa uma imagem customizada no fundo da página inicial."
            />
            <CustomToggle
              checked={!!config.backgroundImage}
              onChange={() =>
                change('backgroundImage', Number(!config.backgroundImage))
              }
            />
          </ToggleRow>
          <LojaInputWrapper>
            <InfoDescription
              label="Tema do Aplicativo"
              description="Seleciona o tema visual para o aplicativo do cliente."
            />
            <CustomSelectPicker
              data={appSelectThemeData}
              value={config.appThemeType || 'auto'}
              onChange={onChange('appThemeType')}
              searchable={false}
              cleanable={false}
            />
          </LojaInputWrapper>
          <LojaInputWrapper style={{ marginTop: 5 }}>
            <InfoDescription
              label="Layout do Cardápio"
              description="Define o estilo de exibição dos itens no cardápio do cliente."
            />
            <CustomSelectPicker
              data={layoutSelectData}
              value={config.layout}
              onChange={onChange('layout')}
              searchable={false}
              cleanable={false}
            />
          </LojaInputWrapper>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaDesktop />
            <h3>Aparência do Painel (Gestor)</h3>
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label="Modo Escuro (Dark Mode)"
              description="Altera o fundo deste painel administrativo para escuro."
            />
            <CustomToggle
              checked={themeSchema === 'dark'}
              onChange={() =>
                handleTheme(themeSchema === 'dark' ? 'light' : 'dark')
              }
            />
          </ToggleRow>
          <ColorPickerWrapper>
            <InfoDescription
              label="Cor Principal do Painel"
              description="Define a cor dos botões de controle apenas do seu gestor."
            />
            <CustomInput
              type="color"
              value={theme.colors.primary}
              onChange={handlePrimaryColor}
            />
          </ColorPickerWrapper>
        </SettingsCard>
      </ContentLoja>
    </ContainerLoja>
  );
};

export default LogoThemes;
